import React from 'react';

import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';

import ReactTooltip from 'react-tooltip';

import bigDecimal from 'js-big-decimal';

import AuthManager from "../../../utils/AuthManager";
import General from "../../../utils/General";
import Processors from "../../../utils/Processors";
import Alert from "../alert/Alert";

import AsyncSelect from "../../components/common/AsyncSelect";
import Notify from "../../../utils/Notify";

const preventNegativeInput = (e) => { if (e.key === '-') e.preventDefault() }

export default class Fees extends React.Component {
  constructor(props) {
    super(props)
    this.state = this._getStateFromProps(props)
  }

  _getStateFromProps(props) {
    const mode = props.mode || "package";
    let rates = props.rates || {
      type: "scheme",
      default: {
        card: null
      },
      schemes: null
    };

    const needsDefaultSchemes = !rates.schemes;
    if (needsDefaultSchemes) {
      rates = { ...rates, schemes: buildDefaultSchemes(mode) };
    }

    return {
      mode,
      loading: false,
      error: null,
      selectedType: "per_payment_method",
      processors: props.processors || [],
      association: props.association,
      packageObject: props.packageObject,
      rates,
      schemesInitialized: needsDefaultSchemes,
    }
  }

  componentDidMount() {
    if (this.state.schemesInitialized) {
      this.props.onUpdate(this.state.rates);
    }
  }

  componentWillReceiveProps(nextProps) {
    const nextState = this._getStateFromProps(nextProps)
    this.setState(nextState)
    if (nextState.schemesInitialized) {
      nextProps.onUpdate(nextState.rates)
    }
  }

  _getSchemeFieldError = (schemeKey, rateType, field) => {
    const schemeError = this.props.errors?.[schemeKey]
    if (this._hasFieldError(schemeError)) return true
    if (!schemeError || typeof schemeError !== 'object') return false

    const errorNode = rateType ? schemeError?.[rateType] : schemeError
    if (this._hasFieldError(errorNode)) return true
    if (!errorNode || typeof errorNode !== 'object') return false

    return this._getMatchingErrorFields(field).some(errorField => {
      return this._hasFieldError(errorNode?.[errorField])
    })
  }

  _hasFieldError = (value) => {
    return Array.isArray(value) || typeof value === 'string'
  }

  _getMatchingErrorFields = (field) => {
    const fieldGroups = {
      flat_value: ['flat_value', 'min_flat_platform_value', 'min_flat_association_value'],
      min_flat_platform_value: ['flat_value', 'min_flat_platform_value', 'min_flat_association_value'],
      min_flat_association_value: ['flat_value', 'min_flat_platform_value', 'min_flat_association_value'],
      percentage_value: ['percentage_value', 'min_percentage_platform_value', 'min_percentage_association_value'],
      min_percentage_platform_value: ['percentage_value', 'min_percentage_platform_value', 'min_percentage_association_value'],
      min_percentage_association_value: ['percentage_value', 'min_percentage_platform_value', 'min_percentage_association_value'],
    }

    return fieldGroups[field] || [field]
  }

  _getInputErrorClass = (schemeKey, rateType, field) => {
    return this._getSchemeFieldError(schemeKey, rateType, field) ? 'fee-input-invalid' : ''
  }

  _handleSchemeChange = (schemeKey, rateType, field, value) => {
    let {
      mode
    } = this.state

    let updatedValue = value ? value : 0.0

    let companyValue = 'flat_value'
    if(field.indexOf("percentage") > -1){
      companyValue = 'percentage_value'
    }

    this.setState((prevState) => {
      const schemes = prevState.rates.schemes || {};
      return {
        rates: {
          ...prevState.rates,
          schemes: {
            ...schemes,

            [schemeKey]: {
              ...(schemes[schemeKey] || {}),

              [rateType]: {
                ...(schemes[schemeKey]?.[rateType] || {}),
                ...(mode === "association" && {[companyValue]: updatedValue}),
                ...((mode === "package" && AuthManager.isAssociate()) && {[companyValue]: updatedValue}),

                [field]: updatedValue,
              },
            },
          },
        },
      };
    }, () => this.props.onUpdate(this.state.rates));
  }

  _handleOtherSchemeChange = (schemeKey, field, value) => {
    const {
      mode
    } = this.state

    const updatedValue = value ? value : 0

    let companyValue = 'flat_value'
    if(field.indexOf("percentage") > -1){
      companyValue = 'percentage_value'
    }

    this.setState((prevState) => {
      const schemes = prevState.rates.schemes || {};
      return {
        rates: {
          ...prevState.rates,
          schemes: {
            ...schemes,

            [schemeKey]: {
              ...(schemes[schemeKey] || {}),

              ...(mode === "association" && {[companyValue]: updatedValue}),
              ...((mode === "package" && AuthManager.isAssociate()) && {[companyValue]: updatedValue}),

              [field]: updatedValue,
            },
          },
        },
      };
    }, () => this.props.onUpdate(this.state.rates));
  }

  _renderProcessorFees() {
    let {
      mode,
      rates,
      processors,
      association,
      packageObject
    } = this.state

    const isStandard = rates.type === "scheme"

    let processorsWithDefault = [
      {
        slug: "default",
        name: "Default",
        className: "default"
      },
      ...processors
    ]

    let isAssociationPackage = packageObject?.association != null

    let schemes = rates?.schemes || {}

    let percentageField = "percentage_value"
    let flatField = "flat_value"
    if(mode === "package"){
      percentageField = AuthManager.isPlatformAdmin() ? "min_percentage_platform_value" : "min_percentage_association_value"
      flatField = AuthManager.isPlatformAdmin() ? "min_flat_platform_value" : "min_flat_association_value"
    }else if(mode === "association"){
      percentageField = "min_percentage_association_value"
      flatField = "min_flat_association_value"
    }

    if(isStandard || association){
      return(
        <>
          <div key={`${schemes?.id || association?.id}-form`} className="form-group row">
            <label className="col-lg-3 col-form-label">
              Authorisation Fee
            </label>
            <div className="col my-auto">
              <div className={`input-group ${this._getInputErrorClass("authorisation", null, flatField)}`}>
                <input
                  className="form-control form-control-solid"
                  type="number"
                  step={"0.01"}
                  min={"0"}
                  onKeyDown={preventNegativeInput}
                  defaultValue={schemes.authorisation?.[flatField] ? (schemes.authorisation?.[flatField] / 100) : 0}
                  onChange={e => {
                    this._handleOtherSchemeChange("authorisation", flatField, Math.round(e.target.value * 100))
                    this._handleOtherSchemeChange("authorisation", percentageField, 0)
                  }}
                />
                <div className="input-group-append">
                  <span className="input-group-text border-0">Flat Fee</span>
                </div>
              </div>
            </div>
            {/*<div className="col my-auto">*/}
            {/*  <div className="input-group">*/}
            {/*    <input*/}
            {/*      className="form-control form-control-solid"*/}
            {/*      type="number"*/}
            {/*      step={"0.01"}*/}
            {/*      defaultValue={schemes.authorisation?.[percentageField] ? bigDecimal.multiply(schemes.authorisation?.[percentageField], 100) : 0}*/}
            {/*      onChange={e =>  this._handleOtherSchemeChange("authorisation", percentageField, parseFloat(bigDecimal.divide(e.target.value, 100)))}*/}
            {/*    />*/}
            {/*    <div className="input-group-append">*/}
            {/*      <span className="input-group-text border-0">%</span>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>

          <div key={`${schemes?.id || association?.id}-table`}  className="c-p-table is-standard table-responsive">
            <table className="table">
              <thead>
              <tr className="method">
                <td rowSpan={3}></td>
                <td className="field" colSpan={4}>
                  <label>Consumer</label>
                </td>
                <td className="field" colSpan={4}>
                  <label>Commercial</label>
                </td>
                <td className="field" colSpan={8}>
                  <label>Surcharges</label>
                  <span className="material-icons-outlined" data-tip data-for='ecom'>info</span>
                  <ReactTooltip id='ecom' effect="solid">
                    in addition to listed %
                  </ReactTooltip>
                </td>
              </tr>
              <tr className="method">
                <td className="field" colSpan={2}>
                  <label>Debit</label>
                </td>
                <td className="field" colSpan={2}>
                  <label>Credit</label>
                </td>
                <td className="field" colSpan={2}>
                  <label>Debit</label>
                </td>
                <td className="field" colSpan={2}>
                  <label>Credit</label>
                </td>
                <td className="field" colSpan={2}>
                  <label>ECOM</label>
                </td>
                <td className="field" colSpan={2}>
                  <label>SoftPOS</label>
                </td>
                <td className="field" colSpan={2}>
                  <label>MOTO</label>
                </td>
                <td className="field" colSpan={2}>
                  <label>ECOM MOTO</label>
                </td>
              </tr>
              <tr className="method">
                <td className="field"><label>Flat Fee</label></td>
                <td className="field"><label>%</label></td>
                <td className="field"><label>Flat Fee</label></td>
                <td className="field"><label>%</label></td>
                <td className="field"><label>Flat Fee</label></td>
                <td className="field"><label>%</label></td>
                <td className="field"><label>Flat Fee</label></td>
                <td className="field"><label>%</label></td>
                <td className="field"><label>Flat Fee</label></td>
                <td className="field"><label>%</label></td>
                <td className="field"><label>Flat Fee</label></td>
                <td className="field"><label>%</label></td>
                <td className="field"><label>Flat Fee</label></td>
                <td className="field"><label>%</label></td>
                <td className="field"><label>Flat Fee</label></td>
                <td className="field"><label>%</label></td>
              </tr>
              </thead>
              <tbody>
                {STANDARD_RATE_TYPES.map((type, index) => {

                  const scheme = schemes?.[type.key] || {}

                  return (
                    <tr
                      className={`method`}
                      key={index}
                    >
                      {/* Starts : Colum : Method */}
                      <td>
                        <div className="name">
                          {type.label}
                        </div>
                      </td>
                      {/* End : Colum : Method */}
                      {STANDARD_SCHEME_FIELDS.map((field, idx) => (
                        <React.Fragment key={`${type.key}-${field}-${idx}`}>
                          <td className="field">
                            <div className={`input-group ${this._getInputErrorClass(type.key, field, flatField)}`}>
                              <input
                                className="form-control form-control-solid"
                                type="number"
                                step={"0.01"}
                                min={"0"}
                                onKeyDown={preventNegativeInput}
                                defaultValue={scheme?.[field]?.[flatField] ? (scheme?.[field]?.[flatField] / 100) : 0}
                                onChange={e => this._handleSchemeChange(type.key, field, flatField, Math.round(e.target.value * 100))}
                              />
                            </div>
                          </td>
                          <td className="field">
                            <div className={`input-group ${this._getInputErrorClass(type.key, field, percentageField)}`}>
                              <input
                                className="form-control form-control-solid"
                                type="number"
                                step={"0.01"}
                                min={"0"}
                                onKeyDown={preventNegativeInput}
                                defaultValue={scheme?.[field]?.[percentageField] ? bigDecimal.multiply(scheme?.[field]?.[percentageField], 100) : 0}
                                onChange={e => {
                                  let value = e.target.value
                                  if (parseFloat(value) > 100) {
                                    value = 100
                                    e.target.value = value
                                    Notify.error("% cannot be more than 100%")
                                  }
                                  this._handleSchemeChange(type.key, field, percentageField, parseFloat(bigDecimal.divide(value, 100)))
                                }}
                              />
                            </div>
                          </td>
                        </React.Fragment>
                      ))}
                    </tr>
                  )
                })}
                {
                  OTHER_RATE_TYPES.map((scheme, index) => (
                    <tr
                      className={`method`}
                      key={index}
                    >
                      <td colSpan={1}>
                        <div className="name">
                          {scheme.label}
                        </div>
                      </td>
                      <td colSpan={8}>
                        <div className={`input-group ${this._getInputErrorClass(scheme.key, null, flatField)}`}>
                          <input
                            className="form-control form-control-solid"
                            type="number"
                            step={"0.01"}
                            min={"0"}
                            onKeyDown={preventNegativeInput}
                            defaultValue={schemes?.[scheme.key]?.[flatField] ? (schemes?.[scheme.key]?.[flatField] / 100) : 0}
                            onChange={e => this._handleOtherSchemeChange(scheme.key, flatField, Math.round(e.target.value * 100))}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text border-0">Flat Fee</span>
                          </div>
                        </div>
                      </td>
                      <td colSpan={8}>
                        <div className={`input-group ${this._getInputErrorClass(scheme.key, null, percentageField)}`}>
                          <input
                            className="form-control form-control-solid"
                            type="number"
                            step={"0.01"}
                            min={"0"}
                            onKeyDown={preventNegativeInput}
                            defaultValue={schemes?.[scheme.key]?.[percentageField] ? bigDecimal.multiply(schemes?.[scheme.key]?.[percentageField], 100) : 0}
                            onChange={e => {
                              let value = e.target.value
                              if (parseFloat(value) > 100) {
                                value = 100
                                e.target.value = value
                                Notify.error("% cannot be more than 100%")
                              }
                              this._handleOtherSchemeChange(scheme.key, percentageField, parseFloat(bigDecimal.divide(value, 100)))
                            }}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text border-0">%</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </>
      )
    }

    return (
      <Tab.Container defaultActiveKey="0" key={packageObject?.id || association?.id}>
        <Nav variant="tabs" className="">
          {processorsWithDefault.map((processor, index) => {
            let logo = Processors.getImage(processor)
            return (
              <Nav.Item
                className={processor.className || ""}
                title={processor.name}
              >
                <Nav.Link eventKey={index}>
                  { logo &&
                    <>
                    <span
                      className='img'
                      style={{ backgroundImage: `url(${logo})` }}
                    />
                      <span className='name'>{processor.name}</span>
                    </>
                  }
                  { !logo &&
                    <span>{processor.name}</span>
                  }
                </Nav.Link>
              </Nav.Item>
            )
            }
          )}
        </Nav>
        <Tab.Content key={packageObject.association?.id || "platform"}>
          {processorsWithDefault.map((processor, index) => {
            return (
              <Tab.Pane eventKey={index}>
                <div className="c-p-table">
                  <table class="table">
                    <tbody>
                    <tr
                      className={`method`}
                    >
                      <td>
                      </td>
                      <td className="field">
                        <label>Percentage</label>
                      </td>
                      <td className="field">
                        <label>Flat</label>
                      </td>
                      <td className="field">
                        <label>Max</label>
                      </td>
                    </tr>
                    {Object.keys(PAYMENT_METHOD_LOGOS).map((paymentMethodType, index) => {
                      packageObject.rates = packageObject.rates || {}
                      let packageProcessorRates = packageObject.rates[processor.slug] || {}
                      let paymentMethodRate = packageProcessorRates[paymentMethodType] || {
                        default: processor.slug == "default"
                      }

                      packageProcessorRates[paymentMethodType] = paymentMethodRate
                      packageObject.rates[processor.slug] = packageProcessorRates

                      let logo = PAYMENT_METHOD_LOGOS[paymentMethodType]

                      let key = isAssociationPackage ? "association" : "platform"
                      let percentage = paymentMethodRate[`${key}_percentage`]
                      let flatCharge = paymentMethodRate[`${key}_flat_charge`]
                      let maxCharge = paymentMethodRate[`${key}_max_charge`]
                      return (
                        <tr
                          className={`method`}
                          key={index}
                        >
                          {/* Starts : Colum : Method */}
                          <td>
                            <div className="name">
                              <span
                                className='img'
                                style={{ backgroundImage: `url(${logo})` }}
                              />
                              {General.snakeCaseToTitleCase(paymentMethodType)}
                            </div>
                          </td>
                          {/* End : Colum : Method */}
                          {/* Starts : Colum : % Fee */}
                          <td className="field">
                            <div className="input-group">
                              <input
                                className="form-control form-control-solid"
                                type="number"
                                defaultValue={percentage ? bigDecimal.multiply(percentage, 100) : ""}
                                placeholder="% Fee"
                                onChange={(e) => {
                                  let value = e.target.value
                                    ? parseFloat(e.target.value)
                                    : null;
                                  if (value > 100) {
                                    value = 100
                                    e.target.value = value
                                    Notify.error("% cannot be more than 100%")
                                  }

                                  let percentage = value ? parseFloat(bigDecimal.divide(value, 100)) : 0
                                  paymentMethodRate[`${key}_percentage`] = percentage
                                  this.setState({ packageObject })
                                }}
                              />
                              <div className="input-group-append">
                                <span className="input-group-text border-0">%</span>
                              </div>
                            </div>
                          </td>
                          {/* End : Colum : % Fee */}

                          {/* Starts : Colum : Flat Fee */}
                          <td className="field">
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <span className="input-group-text border-0">{packageObject.currency.symbol}</span>
                              </div>
                              <input
                                className="form-control form-control-solid"
                                type="number"
                                defaultValue={flatCharge ? flatCharge / 100 : ""}
                                placeholder="Flat Fee"
                                onChange={(e) => {
                                  let flatCharge = e.target.value ? Math.round(parseFloat(e.target.value) * 100) : null
                                  paymentMethodRate[`${key}_flat_charge`] = flatCharge
                                  this.setState({ packageObject })
                                }}
                              />
                            </div>
                          </td>
                          {/* End : Colum : Flat Fee */}

                          {/* Starts : Colum : Max Fee */}
                          <td className="field">
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <span className="input-group-text border-0">{packageObject.currency.symbol}</span>
                              </div>
                              <input
                                className="form-control form-control-solid"
                                type="number"
                                defaultValue={maxCharge ? maxCharge / 100 : ""}
                                placeholder="Max Fee"
                                onChange={(e) => {
                                  let maxCharge = e.target.value ? Math.round(parseFloat(e.target.value) * 100) : null
                                  paymentMethodRate[`${key}_max_charge`] = maxCharge
                                  this.setState({ packageObject })
                                }}
                              />
                            </div>
                          </td>
                          {/* End : Colum : Max Fee */}
                        </tr>
                      )
                    })}
                    </tbody>
                  </table>
                </div>
              </Tab.Pane>
            )}
          )}
        </Tab.Content>
      </Tab.Container>
    )
  }

  _renderInfoBanner() {
    const { infoText } = this.props;

    if (!infoText) {
      return null
    }

    return (
      <Alert
        text={infoText}
        type="note"
        closable={false}
        iconClassName="flaticon-info"
      />
    )
  }

  render() {
    let {
      mode,
      rates,
      association,
      packageObject,
    } = this.state

    let isCompanyDetail = mode === "company_detail";

    return (
      <>
        <div className="section fees">
          {this._renderInfoBanner()}
          {
            !association &&
            <>
              {/* starts : Partner */}
              {!isCompanyDetail && AuthManager.isPlatformAdmin() &&
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label">Partner</label>
                  <div className="col-lg-9 my-auto">
                    <AsyncSelect
                      endpoint={window.Api.Associations}
                      className={'custom-async-select__container'}
                      classNamePrefix={'custom-async-select'}
                      params={{}}
                      disabled={packageObject.id}
                      value={General.getSingleAsyncOption(packageObject.association)}
                      onSelected={association => {
                        packageObject.association = association;
                        // reset the rates when association changes
                        packageObject.rates = {
                          default: {
                            card: null,
                            default: true
                          }
                        };
                        this.setState({ packageObject });
                      }}
                      getOptions={associations => General.getAsyncOptions(associations)}
                    />
                  </div>
                </div>
              }
              {/* end : Partner */}

              {/* starts : Type */}
              <div className="form-group row">
                <label className="col-lg-3 col-form-label">
                  Type
                </label>
                <div className="col-lg-9 my-auto">
                  <div className="select-wrapper">
                    <select
                      className="form-control form-control-solid"
                      value={rates.type}
                      onChange={e => {
                        rates.type = e.target.value;
                        this.setState({ rates });
                      }}
                    >
                      <option value="payment_method">Per Payment Method</option>
                      <option value="scheme">Standard</option>
                    </select>
                  </div>
                </div>
              </div>
              {/* end : Type */}
            </>
          }

          {this._renderProcessorFees()}
        </div>
      </>
    )
  }

}

export const PAYMENT_METHOD_LOGOS = {
  card: require("../../../assets/media/logos/payment-methods/cards.png"),
  sepa: require("../../../assets/media/logos/payment-methods/sepa.png"),
  sepa_instant: require("../../../assets/media/logos/payment-methods/sepa.png"),
  ach: require("../../../assets/media/logos/payment-methods/ach.png"),
  eft: require("../../../assets/media/logos/payment-methods/eft.png"),
  interac: require("../../../assets/media/logos/payment-methods/interac.png"),
  digital_wallet: require("../../../assets/media/logos/payment-methods/digital-wallet.png"),
  klarna:  require("../../../assets/media/logos/payment-methods/klarna.png"),
  faster_payments: require("../../../assets/media/logos/payment-methods/faster-payments.png"),
  bacs: require("../../../assets/media/logos/payment-methods/bacs.png"),
}

const STANDARD_RATE_TYPES = [
  { key: "visa_domestic", label: "VISA - Domestic" },
  { key: "visa_intra", label: "VISA - Intra" },
  { key: "visa_inter", label: "VISA - Inter" },
  { key: "mastercard_domestic", label: "MASTERCARD - Domestic" },
  { key: "mastercard_intra", label: "MASTERCARD - Intra" },
  { key: "mastercard_inter", label: "MASTERCARD - Inter" },
];

const OTHER_RATE_TYPES = [
  { key: "amex", label: "AMEX" },
  { key: "b_schemes", label: "B-Schemes" },
  { key: "apms", label: "APMs" },
  { key: "cashout", label: "Cashout" },
];

const STANDARD_SCHEME_FIELDS = [
  "consumer_debit",
  "consumer_credit",
  "commercial_debit",
  "commercial_credit",
  "ecom",
  "soft_pos",
  "moto",
  "ecom_moto"
];

export function buildDefaultSchemes(mode) {
  let percentageField = "percentage_value";
  let flatField = "flat_value";
  if (mode === "package") {
    percentageField = AuthManager.isPlatformAdmin() ? "min_percentage_platform_value" : "min_percentage_association_value";
    flatField = AuthManager.isPlatformAdmin() ? "min_flat_platform_value" : "min_flat_association_value";
  } else if (mode === "association") {
    percentageField = "min_percentage_association_value";
    flatField = "min_flat_association_value";
  }

  const defaultFieldValues = {
    [flatField]: 0.0,
    [percentageField]: 0.0,
  };

  const schemes = {};

  STANDARD_RATE_TYPES.forEach(({ key }) => {
    schemes[key] = {};
    STANDARD_SCHEME_FIELDS.forEach(field => {
      schemes[key][field] = { ...defaultFieldValues };
    });
  });

  OTHER_RATE_TYPES.forEach(({ key }) => {
    schemes[key] = { ...defaultFieldValues };
  });

  schemes.authorisation = { ...defaultFieldValues };

  return schemes;
}
